import React, { useCallback, useEffect, useState } from "react";
import styles from "../index.module.css";
import {
  CustomButton,
  CustomFileInput,
  CustomTextInput,
} from "../../../../components";
import AxiosInstance, { TokenService } from "../../../../services/Api";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PopupModal from "../../../../components/PopupModal/PopupModal";

const NewsandBlogInfoCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { ID } = location.state || {};
  const user = TokenService.getUser();
  const clientData = user?.client_data[0] || [];
  const school_id = clientData?.school_id || "";

  const userId = user?.id || 0;
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    readMoreLink: "",
    subject: "",
    content: "",
    original_name: null,
    upload_path: "",
  });

  // Modal Popup
  const [modalState, setModalState] = useState({
    open: false,
    type: "success", // "success" | "error"
    message: "",
    redirectPath: "",
  });

  useEffect(() => {
    if (ID) {
      fetchHallOfFame();
    }
  }, [ID]);

  const fetchHallOfFame = async () => {
    const data = {
      school_id: school_id,
      id: ID,
    };

    try {
      const res = await AxiosInstance.post(`/school/listNews`, data);
      if (res.data?.status) {
        const mappedRows = res.data.data.map((item) => ({
          id: item.id,
          upload_path: item.image,
          original_name: item.image,
          readMoreLink: item.link,
          subject: item.subject,
          content: item.content,
        }));

        setFormData(mappedRows[0]);
      }
    } catch (error) {
      console.error("Failed to fetch hall of fame list", error);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.readMoreLink.trim()) {
      newErrors.readMoreLink = translations.errors.readMoreRequired;
    }
    if (!formData.subject.trim()) {
      newErrors.subject = translations.errors.subjectRequired;
    }
    if (!formData.content.trim()) {
      newErrors.content = translations.errors.contentRequired;
    }
    if (!formData.upload_path) {
      newErrors.attachment = translations.errors.imageRequired;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      if (ID) {
        const payload = {
          school_id: school_id,
          user_id: userId,
          link: formData.readMoreLink,
          subject: formData.subject,
          image: formData?.upload_path ? formData?.upload_path : null,
          original_name: formData?.original_name
            ? formData?.original_name
            : null,
          content: formData.content,
          isActive: 1,
          updated_by: userId,
        };
        const response = await AxiosInstance.put(
          `/school/updateNews/${ID}`,
          payload,
        );
        if (response.data?.status) {
          setModalState({
            open: true,
            type: "success",
            message: response.data?.message,
            redirectPath: "/user/ViewNewsAndBlogs",
          });
          setFormData({
            readMoreLink: "",
            subject: "",
            content: "",
            upload_path: null,
          });
        } else {
          setModalState({
            open: true,
            type: "error",
            message: response.data?.message,
            redirectPath: "",
          });

          throw new Error(response.data?.message || "Message send failed");
        }
      } else {
        const payload = {
          school_id: school_id,
          user_id: userId,
          link: formData.readMoreLink,
          subject: formData.subject,
          image: formData?.upload_path ? formData?.upload_path : null,
          original_name: formData?.original_name
            ? formData?.original_name
            : null,
          content: formData.content,
          isActive: 1,
          created_by: userId,
        };
        const response = await AxiosInstance.post(
          `/school/createNews`,
          payload,
        );
        if (response.data?.status) {
          setModalState({
            open: true,
            type: "success",
            message: response.data?.message,
            redirectPath: "/user/content-management",
          });
          setFormData({
            readMoreLink: "",
            subject: "",
            content: "",
            upload_path: null,
          });
        } else {
          setModalState({
            open: true,
            type: "error",
            message: response.data?.message,
            redirectPath: "",
          });

          throw new Error(response.data?.message || "Message send failed");
        }
      }
    } catch (err) {
      console.error("Error sending message:", err);
    }
  };
  const handleCancel = () => {
    setFormData({
      readMoreLink: "",
      subject: "",
      content: "",
      attachment: null,
    });
    setErrors({});
    setFormData({
      readMoreLink: "",
      subject: "",
      content: "",
      attachment: null,
    });
    navigate("/user/content-management");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };
  const handleFileChange = useCallback(async (file) => {
    if (!file) {
      setFormData((prev) => ({
        ...prev,
        original_name: null,
        upload_path: "",
      }));
      setErrors((prev) => ({
        ...prev,
        attachment: "",
      }));
      return;
    }

    // Validate file type
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];

    if (!allowedTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        attachment: "Only jpg, jpeg, png, gif files are allowed",
      }));
      return;
    }

    try {
      const formDataPayload = new FormData();
      formDataPayload.append("content_image", file);
      formDataPayload.append("school_id", school_id);

      const response = await AxiosInstance.post(
        "/content/upload",
        formDataPayload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (Array.isArray(response.data) && response.data.length > 0) {
        const uploadedFile = response.data[0];

        setFormData((prev) => ({
          ...prev,
          original_name: uploadedFile.original_name,
          upload_path: uploadedFile.upload_path,
        }));

        setErrors((prev) => ({
          ...prev,
          attachment: "",
        }));
      } else {
        throw new Error("Invalid upload response");
      }
    } catch (error) {
      console.error("File upload error:", error);
      setErrors((prev) => ({
        ...prev,
        attachment: "Failed to upload file. Please try again.",
      }));
    }
  }, [school_id]);

  const { translations } = useSelector((state) => state.language);

  const handleSuccessOk = () => {
    const { type, redirectPath } = modalState;

    setModalState((prev) => ({
      ...prev,
      open: false,
    }));

    if (type === "success" && redirectPath) {
      navigate(redirectPath);
    }
  };

  return (
    <>
      <PopupModal
        open={modalState.open}
        title={modalState.type === "success" ? "Success" : "Failed"}
        message={modalState.message}
        onOk={handleSuccessOk}
      />

      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <i className="fa-solid fa-table-cells"></i>
          <h2 className={styles.title}>{translations.labels.newsAndBlogs}</h2>
        </div>
        <div className={styles.headerDivider}></div>

        {/* Form */}
        <form onSubmit={handleSubmit} className={styles.form}>
          {/* Row 1: School and Role */}
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <CustomTextInput
                label={translations.labels.subject}
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                placeholder={`${translations.labels.enter} ${" "}${translations.labels.subject}`}
                required
                error={errors.subject}
                maxLength={250}
              />
            </div>
            <div className={styles.formGroup}>
              <CustomTextInput
                label={translations.labels.readMoreLink}
                name="readMoreLink"
                value={formData.readMoreLink}
                onChange={handleInputChange}
                placeholder={`${translations.labels.enter} ${" "}${translations.labels.readMoreLink}`}
                required
                error={errors.readMoreLink}
              />
            </div>
          </div>

          {/* Row 2: Subject (full width on left) */}
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <CustomFileInput
                label={translations.labels.image}
                name="attachment"
                value={formData.original_name || null}
                onChange={handleFileChange}
                accept="image/*"
                required
                placeholder={
                  formData.original_name
                    ? formData.original_name
                    : "No file chosen"
                }
                buttonText="Choose File"
                error={errors.attachment}
              />
            </div>
            <div className={styles.formGroup}>
              <CustomTextInput
                label={translations.labels.content}
                name="content"
                value={formData.content}
                onChange={handleInputChange}
                placeholder={`${translations.labels.enter} ${" "}${translations.labels.content}`}
                required
                error={errors.content}
              />
            </div>
          </div>

          {/* Row 3: Message and Attachment - Aligned straight */}

          {/* Action Buttons */}
          <div className={styles.buttonGroup}>
            <CustomButton
              type="submit"
              variant="contained"
              className={styles.sendButton}
              fullWidth={false}
              // icon={<i className="fa-solid fa-paper-plane"></i>}
              iconPosition="left"
            >
              {translations.labels.save}
            </CustomButton>
            <CustomButton
              type="button"
              variant="contained"
              className={styles.cancelButton}
              fullWidth={false}
              onClick={handleCancel}
              // icon={<i className="fa-solid fa-circle-xmark"></i>}
              iconPosition="left"
            >
              {translations.labels.cancel}
            </CustomButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default NewsandBlogInfoCreate;
